module.exports = __webpack_public_path__ + "assets/retina_Circle3Detailed.cb1e57c9021010d6cedb74215f91b866.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Circle3Detailed.png
// module id = 635
// module chunks = 0